import React,{ createContext, useState, useContext } from "react";
import AuthContext from "./AuthContext";

const PlotData = createContext();
export default PlotData;

export const PlotDataProvider = (props) => {
    const [plotdata, setPlotData] = useState();
    const [attributes, setAttributes] = useState();
    const [cat_attributes, setCatAttributes] = useState();
    const [corrdata, setcorrData] = useState();
    const [nulldata, setnullData] = useState();
    const [corrfeatures, setcorrFeatures] = useState();

    const { authTokens } = useContext(AuthContext);

    
  let getplotData = async () => {
    let response = await fetch(`${process.env.REACT_APP_URL}/get_plot_data/`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + String(authTokens.access),
      },
      body:null,
    });
    const data = await response.json();
    if (response.status === 200) {
      console.log("We Got response for ploting data.");
      setPlotData(data.data);
      setAttributes(data.attributes);
      setCatAttributes(data.cat_attributes);
      // console.log("PlotData", plotdata);
    } else {
      console.log("Data hv not fetch for plot....");
    }
  };


  let getHeatmapData = async () => {
    let response = await fetch(`${process.env.REACT_APP_URL}/get_heatmap_data/`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: null,
    });

    let data = await response.json();

    if(response.status === 200){
      // console
        console.log("Hurray!");
        setcorrData(data.corr_data);
        setnullData(data.null_data);
        setcorrFeatures(data.corr_features);

    }
  };


  let contextData = {
    plotdata:plotdata,
    getplotData:getplotData,
    attributes:attributes,
    cat_attributes:cat_attributes,
    corrdata: corrdata,
    nulldata: nulldata,
    corrfeatures: corrfeatures,
    getHeatmapData: getHeatmapData
  };

  return (<PlotData.Provider value={contextData}>
    {props.children}
  </PlotData.Provider>);
};